var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 0C1.5 0 0 1.5 0 3.33333V20.6667C0 22.5 1.5 24 3.33333 24H30C31.8333 24 33.3333 22.5 33.3333 20.6667V3.33333C33.3333 1.5 31.8333 0 30 0H3.33333ZM3.33333 1.33333H30C31.112 1.33333 32 2.22135 32 3.33333V20.6667C32 21.7786 31.112 22.6667 30 22.6667H3.33333C2.22135 22.6667 1.33333 21.7786 1.33333 20.6667V3.33333C1.33333 2.22135 2.22135 1.33333 3.33333 1.33333ZM5.70833 8.60417L3.22917 14.2708H4.70833L5.25 13H8.04167L8.58333 14.2708H11.3958V10.0625L13.2708 14.2708H14.5417L16.4375 10.125V14.2708H17.8333V8.60417H15.6042L13.8958 12.4167L12.1875 8.60417H10V14.0625L7.5625 8.60417H5.70833ZM19.6667 8.60417V14.2917H25L26.6667 12.3958L28.3125 14.2917H30.0833L27.5833 11.375L30.0833 8.60417H28.3125L26.7083 10.375L25.1667 8.60417H19.6667ZM6.60417 9.79167L7.47917 11.7917H5.77083L6.60417 9.79167ZM21.0417 9.8125L24.4375 9.83333L25.7917 11.375L24.2708 13.0833H21.0417V11.9583H24.125V10.875H21.0417V9.8125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAmex);
export default __webpack_public_path__ + "static/media/logo-amex.76712aacdd7944c1581aec10fabd7695.svg";
export { ForwardRef as ReactComponent };